import Alpine from "alpinejs";

const origin = window.location.origin;

Alpine.data("vimeo", (id) => ({
    href: `https://vimeo.com/${id}`,
    src: `https://player.vimeo.com/video/${id}?autoplay=1&background=0&title=0&byline=0&portrait=0`,
    playing: false,
    showGdpr: false,
    play() {
        this.playing = true;
    },
    popup() {
        openPopup(this.src);
    },
    img: {
        ":src"() {
            return `/api/vimeo-thumbnail/${id}`;
        },
    },
}));

Alpine.data("youtube", (id) => ({
    href: `https://www.youtube.com/watch?v=${id}`,
    src: `https://www.youtube.com/embed/${id}?autoplay=1&amp;modestbranding=1&amp;playsinline=1&amp;rel=0&amp;origin=${origin}`,
    playing: false,
    play() {
        this.playing = true;
    },
    popup() {
        openPopup(this.src);
    },
    img: {
        ":src"() {
            return `/api/youtube-thumbnail/${id}`;
        },
    },
}));

function openPopup(url) {
    const width = Math.min(window.innerWidth, 1000);
    const height = width * ("56.25%" / 100);
    const left = (screen.width - width) / 2;
    const top = (screen.height - height) / 2;
    window.open(
        url,
        "_blank",
        `noopener=yes,directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${width},height=${height},left=${left},top=${top}`,
    );
}
